import { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { PageLayout } from 'shared/ui'
import { MenuAnalytics } from 'widgets/Menu/ui/MenuAnalytics/ui/MenuAnalytics'
import {
  MenuAnalyticsLayoutContext,
  useMenuAnalyticsLayoutContext,
} from 'widgets/Menu/ui/MenuAnalytics/context/menuAnalyticsLayoutContext'
import { MenuAnalyticsLayoutStore } from 'widgets/Menu/ui/MenuAnalytics/store/menuAnalyticsLayoutStore'

const MenuAnalyticsLayoutContent = observer(() => {
  const menuLayoutStore = useMenuAnalyticsLayoutContext()

  return <PageLayout leftContent={<MenuAnalytics />} store={menuLayoutStore.pageLayoutStore} />
})

export const MenuAnalyticsLayout = observer(() => {
  const [menuLayoutStore] = useState(() => new MenuAnalyticsLayoutStore())

  return (
    <MenuAnalyticsLayoutContext.Provider value={menuLayoutStore}>
      <MenuAnalyticsLayoutContent />
    </MenuAnalyticsLayoutContext.Provider>
  )
})
